import type { FC } from 'react';

import type { IconSvgProps } from 'src/components/common/Icons/types';

import { IconSeekPassSupertickSvg } from './IconSeekPassSupertickSvg';

export const IconSeekPassSupertick: FC<IconSvgProps> = ({ ...props }) => (
  <IconSeekPassSupertickSvg {...props} />
);
